import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NbDialogRef } from '@nebular/theme';
import { NgxSpinnerService } from 'ngx-spinner';
import { ReplaySubject, Subscription, takeUntil } from 'rxjs';
import { AnalyticsService } from '../../@core/utils';
import { dateTimeValidator } from '../../@theme/directives/validators';
import { TEACHER_INSTRUCTIONAL_PERIODS, TEACHER_SUBJECT_HOURS } from '../../config/instructional_periods';
import { TEACHERS_LIST } from '../../config/teachers-list';
import { WEEK_DAY_MAP, WeekDays } from '../../config/week-days';
import { ROLES } from '../../enum/roles.enum';
import { EMAIL_TEMPLATE_TYPE } from '../../enum/time_automated_emails.enum';
import { ClearObservableHelper } from '../../helpers/ClearObservableHelper';
import { toUnixTime } from '../../helpers/dateTimeFormatter';
import { Classroom, SchoolCalendar } from '../../interface/calendar';
import { Grades } from '../../interface/grades';
import { School } from '../../interface/school';
import { Subjects } from '../../interface/subject';
import { User } from '../../interface/user';
import { AICreditPointsService } from '../../services/aicredit-points.service';
import { AuthService } from '../../services/auth.service';
import { AutomatedEmailsService } from '../../services/automated-emails.service';
import { CalendarService } from '../../services/calendar.service';
import { ClassroomService } from '../../services/classroom.service';
import { GradeService } from '../../services/grade.service';
import { LessonPlanService } from '../../services/lesson-plan.service';
import { PaymentService } from '../../services/payment.service';
import { SchoolService } from '../../services/school.service';
import { StorageService } from '../../services/storage.service';
import { SubjectService } from '../../services/subject.service';
import { TeacherLessonPlanService } from '../../services/teacher-lesson-plan.service';
import { ToasterService } from '../../services/toaster.service';
import { MatDialogComponent } from '../mat-dialog/mat-dialog.component';
import { UtilService } from './../../services/util.service';
@Component({
  selector: 'ngx-teacher-peroids',
  templateUrl: './teacher-peroids.component.html',
  styleUrls: ['./teacher-peroids.component.scss'],
})
export class TeacherPeroidsComponent extends ClearObservableHelper implements OnInit, OnDestroy {
  currentCalendar: SchoolCalendar[];
  user: User | any;
  grades: Grades[];
  viewDate = new Date();
  @Input() classroom;
  @Input() isModal = false;
  instructionalPeroids: any = [];
  subjects: Subjects[] | any;
  addTeacherPeroidForm: FormGroup;
  selectGradeForm: FormGroup;
  @ViewChild('addTeacherPeroids') addTeacherPeroids: TemplateRef<any>;
  @Output() closeExpandViewModal = new EventEmitter<boolean>();
  @Output() isInitialized = new EventEmitter<boolean>();
  @Input() title: string;
  loading = false;
  weekDays = Object.values(WeekDays);
  teacherPeriods: any = [];
  @Input() currentUser: number;
  // @ViewChild('callAPIDialog') callAPIDialog: TemplateRef<any>;
  isAddPeriod = false;
  subjectHourToUpdate;
  private dialogRef: NbDialogRef<any>;
  isAddAll = false;
  isMock = this.storageService.getItem('user').user['is_trial_user'] ? true : false;
  @Input() isAdminDashboard: boolean;
  @Input() isExpand = false;
  @Input() isEditClassRoom = false;
  @Input() currentSelectedTabSubject: Subjects;
  isTeacherOnlyUser = false;
  schoolForm: FormGroup;
  teachers = [];
  currentTeacher: User;
  bellShedules = [];
  currentBellShedule;
  public teacherFilterCtrl: FormControl = new FormControl();
  public teacherCtrl: FormControl = new FormControl();
  public filteredTeacher: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  @ViewChild('dialogWelcome') dialogWelcome: TemplateRef<any>;
  @Output() saveWeeklyPeriods = new EventEmitter<any>();
  private subscriptionEvents: Subscription;
  @Input() selectedEvents = [];
  isShowClassroomEvents = false;
  @Input() teacherOnlyClassroom: Classroom;
  minDate: Date = new Date();
  selectedSubjectTab: Subjects;
  teacherOnlyClassroomData: any;
  calendarId: any;
  currentTeachingInformation;
  schoolCalendarSubScription: Subscription;
  selectedSchoolCalendar: SchoolCalendar; //variable to store the selected calendar for the selected school
  isTeacherManagement: boolean = false;

  constructor(
    private calendarService: CalendarService,
    public storageService: StorageService,
    public authService: AuthService,
    private gradeService: GradeService,
    private schoolService: SchoolService,
    private subjectService: SubjectService,
    private teacherLessonPlanService: TeacherLessonPlanService,
    private toasterService: ToasterService,
    private fb: FormBuilder,
    public dialog: MatDialog,
    public router: Router,
    public alayticsService: AnalyticsService,
    private classroomService: ClassroomService,
    private spinner: NgxSpinnerService,
    private utilService: UtilService,
    private lessonPlanService: LessonPlanService,
    private paymentService: PaymentService,
    private creditPointService: AICreditPointsService,
    private emailService: AutomatedEmailsService,
  ) {
    super();
    this.subscriptionEvents = this.classroomService.selectedEvents.subscribe((x) => {
      this.isShowClassroomEvents = x.isShow;
      this.selectedEvents = x.isShow === true ? (typeof x.events !== 'undefined' ? x.events : []) : [];
    });
    this.classroomService.selectedSubjectTab.subscribe((x) => {
      this.selectedSubjectTab = x;
      this.updateMultiSubjectEvent(this.selectedSubjectTab);
    });
  }

  public checkIfSelectedPeriod(day: string, period) {
    try {
      return this.selectedEvents.some(
        (x) =>
          x.day === day &&
          period.title === x.period &&
          toUnixTime(period.start) === toUnixTime(x.start) &&
          toUnixTime(period.end) === toUnixTime(x.end) &&
          (this.selectedSubjectTab ? x.subject_id === this.selectedSubjectTab.id : true),
      );
    } catch (error) {
      console.log(error);
    }
  }

  async ngOnInit() {
    try {
      this.spinner.show();
      await this.getFormControls();
      const user = this.storageService.getItem('user');
      this.isTeacherManagement = this.router.url.includes('teacher-management') ? true : false;
      this.user = this.currentUser ? await this.authService.userById(this.currentUser) : user.user;
      this.selectedSchoolCalendar = this.storageService.getItem('selectedSchoolCalendarByAdmin');
      const schoolCalendarData = await this.getSchoolCalendarBySchoolId();
      if (schoolCalendarData && schoolCalendarData.length > 0 && !this.selectedSchoolCalendar) {
        // Store the selected school calendar in local storage to avoid issues during teacher-only onboarding. When a school has multiple bell schedules, this ensures the correct calendar is used instead of defaulting to the one defined in the school table. During teacher-only onboarding, all available school bell schedules are displayed.
        const firstCalendar = schoolCalendarData.find((x) => x.isFirst === true);
        if (firstCalendar) {
          this.selectedSchoolCalendar = firstCalendar;
          this.storageService.setItem('selectedSchoolCalendarByAdmin', this.selectedSchoolCalendar);
        }
      }

      // Subscribe to changes in the selected school calendar from local storage to update the form data accordingly when the calendar is changed by the admin.
      this.storageService.setSelectedSchoolsCalendarToLocalStorage
        .pipe(takeUntil(this.destroy$))
        .subscribe(async (res) => {
          if (res) {
            this.spinner.show();
            this.selectedSchoolCalendar = this.storageService.getItem('selectedSchoolCalendarByAdmin');
            this.currentCalendar = res;
            await this.getNewlyAddedTeachingInformation();
            await this.getInstructionalPeriods();
            this.spinner.hide();
          }
        });
      // Get the academic information for teachers
      if (this.title !== 'administration') {
        await this.getNewlyAddedTeachingInformation();
      }
      // Made the isAdminDashboard flag as false for the teacher only users
      if (this.user && this.user.role_id === ROLES.TEACHER_ONLY) {
        this.isAdminDashboard = false;
        this.isTeacherOnlyUser = true;
      }
      if (this.isAdminDashboard) {
        await this.getAdminDashboardData();
      } else {
        if (!this.isTeacherOnlyUser) {
          await this.getInstructionalPeriods();
        }
      }

      this.storageService.setSelectedSchoolsToLocalStorage.subscribe(async (res) => {
        if (res) {
          this.spinner.show();
          await this.getAdminDashboardData();
          this.spinner.hide();
        }
      });
      this.filterTeacher();
      this.teacherFilterCtrl.valueChanges.subscribe(() => {
        this.filterTeacher();
      });

      this.isInitialized.emit(true);
      this.spinner.hide();
    } catch (error) {
      // console.log(error);
      this.isInitialized.emit(true);
      this.spinner.hide();
    }
  }

  async getAdminDashboardData() {
    try {
      const localStorage = this.storageService.getItem('selectedSchoolByAdmin');
      const currentSchoolId = localStorage?.id ? localStorage?.id : Number(this.user.school_id);
      await this.getTeachersBySchoolId(currentSchoolId);
    } catch (error) {
      // console.log(error);
    }
  }

  async getInstructionalPeriods() {
    try {
      this.spinner.show();

      if (!this.classroom) {
        if (!this.isMock) {
          this.currentCalendar = (await this.getSchoolCalendarBySchoolId()) as any;
          if (this.title === 'administration') {
            // we want to set the get the calendar first time created for the school
            const calendar = this.currentCalendar.find((x) => x.isFirst === true);
            this.calendarId = calendar;
          }
          this.grades = (await this.getGradesByIds()) as any;
          this.subjects = await this.getSubjectByIds();
          this.grades && this.grades.length > 0 ? await this.initialTeacherPeroids() : (this.instructionalPeroids = []);
        } else {
          await this.initialTeacherPeroids();
        }
      } else {
        await this.initialTeacherPeroids();
      }
      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      console.log(error);
    }
  }

  async initialTeacherPeroids() {
    try {
      this.spinner.show();
      this.selectGradeForm.controls.grade.setValue('all');
      if (this.classroom) {
        if (this.isModal) {
          if (
            this.teacherLessonPlanService.instructionalPeriods &&
            this.teacherLessonPlanService.instructionalPeriods.length > 0
          ) {
            this.instructionalPeroids = this.teacherLessonPlanService.instructionalPeriods;
          } else {
            await this.getAllInstructionalDays();
          }
        } else {
          await this.getAllInstructionalDays();
        }
      } else {
        await this.getAllInstructionalDays();
      }
      this.spinner.hide();
    } catch (error) {}
  }

  /**
   * @description Function to get all instructional days
   * @param grade
   * @param isLoad
   */
  async getAllInstructionalDays(grade?: string, isLoad = false) {
    try {
      this.spinner.show();

      const body: any = { user_id: this.user.id };

      // Step 1: Handle teacher without bell schedule
      if (
        !isLoad &&
        this.user?.teachingInfo?.bellShedule === 'false' &&
        !this.isTeacherManagement &&
        (!this.currentTeachingInformation || this.currentTeachingInformation?.length === 0)
      ) {
        if (this.isTeacherOnlyUser) await this.schoolById();

        const periods: any = await this.teacherBellShedulePeriods();
        this.instructionalPeroids = periods?.school_periods || [];
        // If the teacher has created a custom bell schedule, keep the dropdown empty to avoid confusion caused by showing the school's bell schedules.
        this.bellShedules = [];
        this.currentBellShedule = null;
      } else {
        if (!isLoad) {
          // Do not switch bell schedule after adding/removing periods
          await this.schoolById(this.currentBellShedule?.id ? this.currentBellShedule?.id : null);
        }

        // Step 2: Handle mock/admin dashboard
        this.isAdminDashboard = this.title === 'administration' && this.isMock;
        if (this.isAdminDashboard && this.isMock) {
          this.instructionalPeroids = TEACHER_INSTRUCTIONAL_PERIODS;
          this.teacherPeriods = TEACHER_SUBJECT_HOURS;
          if (this.currentBellShedule?.id) body.school_bell_shedules_id = this.currentBellShedule.id;
          this.spinner.hide();
          return;
        }

        // Step 3: Determine instructional periods
        await this.setInstructionalPeriods(body);

        // Step 4: Add bell schedule and grade info to request
        if (this.currentBellShedule?.id) body.school_bell_shedules_id = this.currentBellShedule.id;
        if (grade && grade !== 'all') body.grade_id = grade;
      }
      // Handle teacher with custom bell schedule
      const teachingInfo =
        this.selectedSchoolCalendar && !this.selectedSchoolCalendar.isFirst
          ? this.currentTeachingInformation?.[0]?.teachingInfo
          : this.user.teachingInfo;
      if (teachingInfo?.bellShedule === 'false') {
        delete body['school_bell_shedules_id'];
        body['teacher_bell_shedule_id'] = teachingInfo?.teacherBellScheduleId;
      }
      if (teachingInfo?.bellShedule === 'true') {
        // && teachingInfo?.schoolBellScheduleId
        delete body['teacher_bell_shedule_id'];
        body['school_bell_shedules_id'] =
          this.currentBellShedule &&
          this.currentBellShedule.id &&
          this.selectedSchoolCalendar &&
          this.selectedSchoolCalendar.isFirst
            ? this.currentBellShedule.id
            : (this.currentBellShedule?.id ?? this.bellShedules[0]?.id ?? 0);
      }

      // Pass the selected calendar id
      body['school_calendar_id'] = this.selectedSchoolCalendar
        ? this.selectedSchoolCalendar?.id
        : this.calendarId
          ? this.calendarId.id
          : 0;
      // Step 5: Fetch teacher subject hours
      this.teacherPeriods = this.user.is_trial_user
        ? await this.teacherLessonPlanService.getTeacherSubjectHours({}, true)
        : await this.teacherLessonPlanService.getTeacherSubjectHoursByUserId(body);

      // Step 6: Sort instructional periods
      this.sortInstructionalPeriods();

      await this.updateInstructionPeriods();

      this.teacherLessonPlanService.instructionalPeriods = this.instructionalPeroids;
    } catch (error) {
      console.error('Error in getAllInstructionalDays:', error);
    } finally {
      this.spinner.hide();
    }
  }

  /**
   * @description Helper to determine instructional periods
   * @param body
   */
  private async setInstructionalPeriods(body: any) {
    try {
      const teachingInfo = this.currentTeachingInformation?.[0]?.teachingInfo;

      // When user is on teacher academic year setup
      if (!this.isTeacherManagement) {
        if (!this.currentTeachingInformation) {
          this.instructionalPeroids = this.currentBellShedule?.bell_schedule || [];
          return;
        }

        if (teachingInfo?.bellShedule === 'false') {
          const bellSchedule = await this.schoolService.getTeacherBellSchedulesById(teachingInfo.teacherBellScheduleId);
          this.instructionalPeroids = bellSchedule.school_periods || [];
        } else {
          if (teachingInfo) {
            const bellSchedule = this.currentBellShedule?.bell_schedule;
            this.instructionalPeroids = bellSchedule.bell_schedule || bellSchedule || [];
          } else {
            this.instructionalPeroids = this.currentBellShedule?.bell_schedule || [];
          }
        }
      } else {
        // For teacher management flow
        if (teachingInfo?.bellShedule === 'false') {
          const bellSchedule = await this.schoolService.getTeacherBellSchedulesById(teachingInfo.teacherBellScheduleId);
          this.instructionalPeroids = bellSchedule.school_periods || [];
          body.teacher_bell_shedule_id = teachingInfo.teacherBellScheduleId;
        } else {
          this.instructionalPeroids = this.currentBellShedule?.bell_schedule || [];
        }
      }
    } catch (error) {
      console.log('TeacherPeroidsComponent ~ setInstructionalPeriods ~ error:', error);
    }
  }

  /**
   * @description Helper to sort instructional periods
   */
  private sortInstructionalPeriods() {
    const map = WEEK_DAY_MAP;
    this.instructionalPeroids.sort((a, b) => map[a.day] - map[b.day]);
  }

  async updateInstructionPeriods() {
    try {
      this.instructionalPeroids.map((instructionalPeriod) => {
        const filteredData = this.teacherPeriods.filter(
          (teacherPeriod) => teacherPeriod.day === instructionalPeriod.day,
        );
        if (filteredData && filteredData.length > 0) {
          instructionalPeriod.periods.forEach((element) => {
            // Match periods by title AND normalized start/end times
            const matchedTeacherPeriod = filteredData.find(
              (x) =>
                x.peroid.trim().toLowerCase() === element.title.trim().toLowerCase() &&
                toUnixTime(x.start) === toUnixTime(element.start) &&
                toUnixTime(x.end) === toUnixTime(element.end),
            );
            element.subject = matchedTeacherPeriod?.subject?.subject;
            element.grade = matchedTeacherPeriod?.grades?.grade;
          });
        }

        return instructionalPeriod;
      });
    } catch (error) {
      // console.log(error);
    }
  }

  async getSubjectByIds() {
    try {
      let body;
      if (this.title === 'teacherNewAcademicYearSetup') {
        this.currentTeachingInformation = await this.getNewlyAddedTeachingInformation();
        body = {
          subject_ids: this.currentTeachingInformation?.[0]?.teachingInfo?.teachingSubject,
        };
      } else {
        // Derive the teachingInfo source based on selectedSchoolCalendar.isFirst, like getAllInstructionalDays does
        const teachingInfo =
          this.selectedSchoolCalendar && !this.selectedSchoolCalendar.isFirst
            ? this.currentTeachingInformation?.[0]?.teachingInfo
            : this.user.teachingInfo;
        // Use length check instead of truthiness check to avoid treating empty arrays as valid
        const subjects =
          teachingInfo?.teachingSubject?.length > 0
            ? teachingInfo.teachingSubject
            : this.user.teachingInfo.teachingSubject;

        body = {
          subject_ids: subjects,
        };
      }
      return await this.subjectService.getSubjectsByIds(body);
    } catch (error) {
      // console.log(error);
    }
  }

  async getFormControls() {
    try {
      this.selectGradeForm = this.fb.group({
        grade: [''],
      });
      this.addTeacherPeroidForm = this.fb.group({
        subject: ['', Validators.required],
        grade: ['', Validators.required],
        isAddAll: [''],
      });
      this.schoolForm = this.fb.group({
        startDate: ['', Validators.required],
        endDate: ['', Validators.required],
        startTime: ['', Validators.required],
        endTime: ['', Validators.required],
        // calendar_title: ['', [validateNameAndSpace]],
      });
      this.validateSchoolDate();
      this.validateSchoolEndTime();
    } catch (error) {
      // console.log(error);
    }
  }

  async getGradesByIds() {
    try {
      if (this.user.teachingInfo.teachingGrades && this.user.teachingInfo.teachingGrades.length > 0) {
        let body;
        if (this.title === 'teacherNewAcademicYearSetup') {
          this.currentTeachingInformation = await this.getNewlyAddedTeachingInformation();
          body = {
            grades: this.currentTeachingInformation?.[0]?.teachingInfo?.teachingGrades,
          };
        } else {
          // Derive the teachingInfo source based on selectedSchoolCalendar.isFirst, like getAllInstructionalDays does
          const teachingInfo =
            this.selectedSchoolCalendar && !this.selectedSchoolCalendar.isFirst
              ? this.currentTeachingInformation?.[0]?.teachingInfo
              : this.user.teachingInfo;

          // Use length check instead of truthiness check to avoid treating empty arrays as valid
          const grades =
            teachingInfo?.teachingGrades?.length > 0
              ? teachingInfo.teachingGrades
              : this.user.teachingInfo.teachingGrades;

          body = {
            // currentTeachingInformation holds new academic year data for the selected calendar.
            // If the calendar is the base calendar (isFirst=true), use this.user.teachingInfo.teachingGrades.
            // New academic year data will only be available when the user is on the teacher new academic year setup page and has added data for the selected calendar.
            grades: grades,
          };
        }

        return await this.gradeService.getGradesByIds(body);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async getBellScheduleAndPeriods(bellSchedule) {
    try {
      this.spinner.show();

      if (bellSchedule && bellSchedule.id) {
        this.user.teachingInfo.schoolBellScheduleId = bellSchedule?.id;
        // Update the bell schedule id in the current teaching information
        if (this.currentTeachingInformation?.[0]) {
          if (this.currentTeachingInformation[0].teachingInfo.bellSchedule === 'true') {
            this.currentTeachingInformation[0].teachingInfo.schoolBellScheduleId = bellSchedule?.id;
          }
        }
        await this.schoolById(bellSchedule?.id);
      } else {
        delete this.user.teachingInfo.schoolBellScheduleId;
        await this.schoolById(null, true);
      }
      await this.getAllInstructionalDays(null, true);
      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      // console.log(error)
    }
  }

  async schoolById(id?: number, isChange = false) {
    try {
      const response: any = await this.schoolService.schoolById(this.user.school_id);
      await this.getSchoolBellShedules(response, id, isChange);
    } catch (error) {
      // console.log(error);
    }
  }

  async getSchoolBellShedules(school: School, id?: number, isChange = false) {
    try {
      this.spinner.show();

      const response = await this.schoolService.getSchoolBellShedules({
        school_id: this.user?.school_id,
        school_calendar_id:
          this.selectedSchoolCalendar && !this.selectedSchoolCalendar?.isFirst ? this.selectedSchoolCalendar?.id : 0,
      });
      if (
        (school?.school_periods?.length > 0 && this.selectedSchoolCalendar && this.selectedSchoolCalendar?.isFirst) ||
        (this.title === 'administration' && this.user?.teachingInfo.bellShedule === 'true')
      ) {
        this.bellShedules = [
          {
            bell_schedule: school?.school_periods,
            school_id: school?.id,
            name: school?.schoolData?.bell_schedule_name,
          },
          ...response,
        ];
        // keep the bell schedule empty when user is on the teacher new academic year setup page
        if (this.selectedSchoolCalendar?.id && response.length > 0 && !this.selectedSchoolCalendar?.isFirst) {
          this.bellShedules = this.bellShedules.filter((x) => x.school_calendar_id === this.selectedSchoolCalendar?.id);
        }
      } else {
        if (
          this.title === 'teacherNewAcademicYearSetup' &&
          this.currentTeachingInformation[0]?.teachingInfo?.bellShedule === 'false'
        ) {
          this.bellShedules = [];
        } else {
          // These if conditions were added to prevent displaying the weekly period on the teacher details page for admin and super admin users, if the teacher is not onboarded for the selected academic year in header or if the school calendar differs from the onboarding calendar
          if (
            this.isAdminDashboard &&
            this.currentTeachingInformation.length === 0 &&
            this.selectedSchoolCalendar &&
            !this.selectedSchoolCalendar?.isFirst
          ) {
            this.bellShedules = [];
          } else {
            this.bellShedules = response;
            if (this.currentTeachingInformation?.[0]?.teachingInfo?.bellShedule === 'false') {
              this.bellShedules = [];
            }
          }
        }
      }
      const currentId = isChange
        ? 0
        : id
          ? id
          : this.selectedSchoolCalendar && !this.selectedSchoolCalendar?.isFirst
            ? this.currentTeachingInformation[0]?.teachingInfo?.schoolBellScheduleId
            : this.user?.teachingInfo?.schoolBellScheduleId;
      const filter = this.bellShedules.filter((x) => x?.id === currentId);
      this.currentBellShedule = filter?.length > 0 ? filter[0] : this.bellShedules[0];

      if (Array.isArray(this.currentBellShedule?.bell_schedule)) {
        this.currentBellShedule.bell_schedule = this.currentBellShedule.bell_schedule.flat();
      }
      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      console.log(error);
    }
  }

  async teacherBellShedulePeriods() {
    try {
      const parans = {
        user_id: this.user.id,
      };

      const teacherBellShedule = await this.schoolService.teacherBellSheduleByUserId(parans);

      return teacherBellShedule[0];
    } catch (error) {
      // console.log(error)
    }
  }

  async getSchoolCalendarBySchoolId() {
    try {
      this.currentCalendar = [];
      const params = {
        school_id: this.user.school_id,
      };
      return await this.calendarService.schoolCalendarBySchoolId(params);
    } catch (error) {
      // console.log(error);
    }
  }

  closeExpandView() {
    this.closeExpandViewModal.emit(true);
  }

  async addPeroid(period, day) {
    try {
      if (this.user.is_trial_user) return;
      if (!this.classroom) {
        if (
          period &&
          (period?.title.toLowerCase().includes('period') || period?.title.toLowerCase().includes('block')) &&
          !period?.subject &&
          !period?.grade &&
          this.selectGradeForm.value.grade === 'all'
        ) {
          await this.openAddPacingPlanDialog(day, period.title, period.start, period.end, true);
        } else {
          period && !period?.title.toLowerCase().includes('period') && !period?.title.toLowerCase().includes('block')
            ? this.toasterService.showToast(`We have a ${period.title} here`, 'info')
            : this.selectGradeForm.value.grade !== 'all'
              ? this.toasterService.showToast('Please select grade to all to add instructional period', 'info')
              : this.updateInstructionPeriodsDialog(
                  period.subject,
                  period.grade,
                  day,
                  period.title,
                  period.start,
                  period.end,
                );
        }
      }
    } catch (error) {
      // console.log(error);
    }
  }

  updateInstructionPeriodsDialog(subject, grade, day, title, start, end): void {
    try {
      const selectedGrade = this.grades.filter((x) => x.grade === grade);
      const selectedSubject = this.subjects.filter((x) => x.subject === subject);

      this.addTeacherPeroidForm.patchValue({
        subject: selectedSubject[0].id,
        grade: selectedGrade[0].id,
      });

      this.openAddPacingPlanDialog(day, title, start, end);
    } catch (error) {
      // console.log(error);
    }
  }

  async openAddPacingPlanDialog(day: string, peroid: string, start: number, end: number, isAdd = false) {
    try {
      this.isAddAll = false;
      if (isAdd) {
        this.isAddPeriod = true;
        this.addTeacherPeroidForm.reset();
      } else {
        this.isAddPeriod = false;

        // Match exact period by day, title, and normalized start/end timestamps
        // This avoids failures when UI times are ISO/string values while teacherPeriods contains epoch numbers.
        this.subjectHourToUpdate = this.teacherPeriods.find(
          (x) =>
            x.day === day &&
            x.peroid?.trim().toLowerCase() === peroid?.trim().toLowerCase() &&
            toUnixTime(x.start) === toUnixTime(start) &&
            toUnixTime(x.end) === toUnixTime(end) &&
            x.subject_id === this.addTeacherPeroidForm.value.subject &&
            x.grades_id === this.addTeacherPeroidForm.value.grade,
        );
      }

      this.dialog.open(this.addTeacherPeroids, {
        width: '550px',
        height: '320px',
        data: {
          peroid: peroid,
          day: day,
          startTime: start,
          endTime: end,
        },
      });
    } catch (error) {
      // console.log(error);
    }
  }

  // Adds a period to all days of the week for a specific time slot (row)
  // @param period - Period title (e.g., "Period")
  // @param start - Start time of the period to match exact row
  // @param end - End time of the period to match exact row
  async addPeriodToAllDays(period: string, start: number, end: number) {
    try {
      this.spinner.show();
      this.dialog.closeAll();

      // Filter by period title AND normalized start/end times to match only the specific row
      // Normalizing prevents failures when UI times are ISO strings while teacherPeriods stores epoch numbers
      const teacherPeriodsToUpdate = this.teacherPeriods.filter(
        (x) =>
          x.peroid?.trim().toLowerCase() === period?.trim().toLowerCase() &&
          toUnixTime(x.start) === toUnixTime(start) &&
          toUnixTime(x.end) === toUnixTime(end),
      );
      teacherPeriodsToUpdate.map((teacherPeriod) => {
        teacherPeriod.subject_id = this.addTeacherPeroidForm.value.subject;
        teacherPeriod.grades_id = this.addTeacherPeroidForm.value.grade;
        teacherPeriod.isAdd = false;
      });
      const newPeriodsToAdd = [];

      this.instructionalPeroids.map((x) => {
        x.periods.map((per) => {
          // Only match periods with exact title and normalized time slot to avoid affecting other rows
          if (
            per.title?.trim().toLowerCase() === period?.trim().toLowerCase() &&
            toUnixTime(per.start) === toUnixTime(start) &&
            toUnixTime(per.end) === toUnixTime(end) &&
            !per.subject &&
            !per.grade
          ) {
            per['day'] = x.day;
            newPeriodsToAdd.push(per);
          }
        });
      });
      for (const iterator of newPeriodsToAdd) {
        const body = {
          user_id: this.user.id,
          subject_id: this.addTeacherPeroidForm.value.subject,
          grades_id: this.addTeacherPeroidForm.value.grade,
          day: iterator.day,
          start: iterator.start,
          end: iterator.end,
          peroid: iterator.title.toLowerCase(),
          isAdd: true,
        };

        body['school_bell_shedules_id'] = this.currentBellShedule?.id
          ? this.currentBellShedule?.id
          : this.user?.teachingInfo?.schoolBellScheduleId
            ? this.user?.teachingInfo?.schoolBellScheduleId
            : 0;
        // Store the teacher bell schedule
        // Made the teacher information optional chaining to avoid error
        if (this.currentTeachingInformation?.[0]?.teachingInfo?.bellShedule === 'false') {
          body['teacher_bell_shedule_id'] = this.currentTeachingInformation[0].teachingInfo.teacherBellScheduleId;
        } else {
          if (this.title === 'administration' && this.user?.teachingInfo?.bellShedule === 'false') {
            body['teacher_bell_shedule_id'] = this.user.teachingInfo.teacherBellScheduleId;
          } else {
            body['teacher_bell_shedule_id'] = this.user?.teachingInfo?.teacherBellScheduleId ?? 0;
          }
        }

        body['school_calendar_id'] = this.selectedSchoolCalendar?.id
          ? this.selectedSchoolCalendar?.id
          : this.calendarId
            ? this.calendarId
            : 0;
        teacherPeriodsToUpdate.push(body);
      }

      const params = {
        teacher_periods: teacherPeriodsToUpdate,
      };
      const response: any = await this.teacherLessonPlanService.addAndUpdateMultipleSubjectHours(params);

      if (response && response.id) {
        await this.getInstructionalPeriods();
      }
      // set isAddAll value as false
      this.addTeacherPeroidForm.controls.isAddAll.setValue(false);
      this.spinner.hide();
    } catch (error) {
      console.log('TeacherPeroidsComponent ~ addPeriodToAllDays ~ error:', error);
      this.spinner.hide();
    }
  }

  async addTeacherPeroid(day: string, peroid: string, start: number, end: number) {
    try {
      this.spinner.show();
      this.dialog.closeAll();

      if (this.isAddPeriod) {
        await this.addTeacherPeriodToDatabase(day, peroid, start, end);
      } else {
        await this.updateTeacherPeriodToDatabase();
      }
      // set isAddAll value as false
      this.addTeacherPeroidForm.controls.isAddAll.setValue(false);
      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
    }
  }

  async updateTeacherPeriodToDatabase() {
    try {
      this.spinner.show();
      const body = {
        teacher_subject_hours_id: this.subjectHourToUpdate.id,
        user_id: this.subjectHourToUpdate.user_id,
        subject_id: this.addTeacherPeroidForm.value.subject,
        grades_id: this.addTeacherPeroidForm.value.grade,
        day: this.subjectHourToUpdate.day,
        start: this.subjectHourToUpdate.start,
        end: this.subjectHourToUpdate.end,
        peroid: this.subjectHourToUpdate.peroid,
        school_calendar_id: this.selectedSchoolCalendar?.id
          ? this.selectedSchoolCalendar?.id
          : this.calendarId
            ? this.calendarId
            : 0,
      };

      if (this.subjectHourToUpdate?.school_bell_shedules_id)
        body['school_bell_shedules_id'] = this.subjectHourToUpdate?.school_bell_shedules_id;

      const response = await this.teacherLessonPlanService.updateTeacherHours(this.subjectHourToUpdate.id, body);

      this.selectGradeForm.patchValue({ grade: 'all' });
      response && response.id ? await this.getAllInstructionalDays() : null;
      this.addTeacherPeroidForm.reset();
      this.spinner.hide();
    } catch (error) {
      // console.log(error);
    }
  }

  async addTeacherPeriodToDatabase(day: string, peroid: string, start: number, end: number) {
    try {
      this.spinner.show();
      const body = {
        user_id: this.user.id,
        subject_id: this.addTeacherPeroidForm.value.subject,
        grades_id: this.addTeacherPeroidForm.value.grade,
        day: day,
        start: start,
        end: end,
        peroid: peroid.toLowerCase(),
        school_calendar_id: this.selectedSchoolCalendar?.id
          ? this.selectedSchoolCalendar?.id
          : this.calendarId
            ? this.calendarId
            : 0,
      };

      if (this.currentBellShedule?.id)
        body['school_bell_shedules_id'] = this.currentBellShedule?.id
          ? this.currentBellShedule?.id
          : this.user?.teachingInfo?.schoolBellScheduleId
            ? this.user?.teachingInfo?.schoolBellScheduleId
            : 0;
      // Store the teacher bell schedule
      //  Made the teacher information optional chaining to avoid error
      if (this.currentTeachingInformation?.[0]?.teachingInfo?.bellShedule === 'false') {
        body['teacher_bell_shedule_id'] = this.currentTeachingInformation[0].teachingInfo.teacherBellScheduleId;
      } else {
        if (this.title === 'administration' && this.user?.teachingInfo?.bellShedule === 'false') {
          body['teacher_bell_shedule_id'] = this.user.teachingInfo.teacherBellScheduleId;
        } else {
          // Set teacher bell schedule id based on the selected calendar
          if (this.selectedSchoolCalendar && !this.selectedSchoolCalendar?.isFirst) {
            body['teacher_bell_shedule_id'] =
              this.currentTeachingInformation?.[0]?.teachingInfo?.bellShedule === 'false'
                ? this.currentTeachingInformation[0].teachingInfo.teacherBellScheduleId
                : 0;
          } else {
            body['teacher_bell_shedule_id'] = this.user?.teachingInfo?.teacherBellScheduleId ?? 0;
          }
        }
      }
      const response: any = await this.teacherLessonPlanService.addTeacherSubjectHours(body);

      this.selectGradeForm.patchValue({ grade: 'all' });
      response && response.id ? await this.getAllInstructionalDays() : null;
      this.addTeacherPeroidForm.reset();
      this.spinner.hide();
    } catch (error) {
      console.log('TeacherPeroidsComponent ~ addTeacherPeriodToDatabase ~ error:', error);
    }
  }

  openConfirmationDialog(): void {
    const dialogRef = this.dialog.open(MatDialogComponent, {
      width: '400px',
      data: {
        title: this.isTeacherOnlyUser ? 'Save Calendar Setup' : 'Save Weekly Periods',
        icon: '/assets/icons/save-featured-icon.svg',
        accessCodeLabel: this.isTeacherOnlyUser ? 'Save Calendar Setup' : 'Save Weekly Periods',
        confirmationMessage: this.isTeacherOnlyUser
          ? 'This will be a one time process to add your calendar, You will not be able to modify this information after this screen'
          : 'This will be a one time process to add your weekly periods, You will not be able to modify this information after this screen',
        cancelButtonText: 'Cancel',
        confirmButtonText: 'Save And Next',
        cancelTrackEvent: 'Cancel Save Weekly Periods',
        confirmTrackEvent: 'Save Weekly Periods',
        trackPage: this.isTeacherOnlyUser ? 'Calendar Setup' : 'Teacher Period',
      },
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        if (!this.isTeacherOnlyUser) {
          this.submit();
        } else {
          this.createNewSchoolForUser();
        }
      }
    });
  }

  async deleteTeacherPeriod(isDialog = false) {
    try {
      this.spinner.show();
      if (isDialog) {
        this.dialog.closeAll();
        // this.dialogRef = this.dialogService.open(dialog, {
        //   context: 'this is some additional data passed to dialog',
        // });
        this.openConfirmDeleteDialog();
      } else {
        this.teacherLessonPlanService.delteTeacherPeriodHour(this.subjectHourToUpdate.id);
        // this.dialogRef.close();
        this.selectGradeForm.patchValue({ grade: 'all' });
        await this.getAllInstructionalDays();
        this.addTeacherPeroidForm.reset();
      }
      this.spinner.hide();
    } catch (error) {
      // console.log(error);
      this.spinner.hide();
    }
  }
  async getTeachersBySchoolId(schoolId: number) {
    try {
      this.spinner.show();
      if (this.isMock) {
        this.teachers = TEACHERS_LIST;
        if (this.teachers?.length > 0) {
          this.currentTeacher = this.teachers[0];
          await this.getPeriodsByTeacherId();
        }
      } else {
        const body = {
          school_id: schoolId,
        };
        let response;
        if (this.isAdminDashboard === true) {
          response = await this.authService.getTeachersBySchoolId(body);
        } else {
          response = await this.authService.teachersBySchoolId(body);
        }
        this.teachers = response;
        if (this.teachers?.length > 0) {
          this.currentTeacher = this.teachers[0];
          await this.getPeriodsByTeacherId();
        }
      }
      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      // console.log(error);
    }
  }
  async getPeriodsByTeacherId() {
    try {
      this.spinner.show();
      // this.user = this.currentTeacher;
      await this.getInstructionalPeriods();
      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
    }
  }
  closeDialog() {
    try {
      this.authService.closeDialog.emit(true);
    } catch (error) {
      // console.log(error);
    }
  }

  async submit() {
    try {
      this.spinner.show();
      if (this.title === 'teacherNewAcademicYearSetup') {
        //if teacher new academic year setup is completed then we are navigating to teacher dashboard
        await this.getAcademicInformation();
        this.authService.disabledSideMenu.emit(false);
        this.router.navigateByUrl('/test-quizzes');
        return;
      }
      const classrooms = await this.classroomService.getClassroomByUserId({
        user_id: this.user.id,
      });
      if (classrooms && classrooms.some((x) => x.subject_id.length > 1) && this.teacherPeriods.length > 0) {
        this.getLessonPlansPerClassroomsAndUpdateDates(classrooms.filter((x) => x.subject_id.length > 1));
      }

      const body = {
        user_id: this.user?.id,
        firstName: this.user?.firstName,
        lastName: this.user?.lastName,
        email: this.user?.email,
        role_id: this.user?.role_id,
        school_id: this.user?.school_id,
        isNewUser: false,
        profileData: {
          ...this.user?.profileData,
          currentRoute: '/test-quizzes',
        },
        password: this.user?.password,
        teachingInfo: this.user?.teachingInfo,
        user_profile_media_id: this.user?.user_profile_media_id,
        address: this.user?.address,
        contact: this.user?.contact,
        birthdate: this.user?.birthdate,
        school_indentity_number: this?.user?.school_indentity_number,
        is_trial_user: this.user.is_trial_user,
        uid: this.user?.uid,
        provider_id: this.user?.provider_id,
        proxy_email: this.user?.proxy_email,
        isTeacherOnlyOnBoarded: this.user?.isTeacherOnlyOnBoarded,
        last_login_location: this.user?.last_login_location,
      };

      if (!classrooms?.some((x) => x.subject_id.length === 1)) {
        delete body['profileData'].isClassroomsSetup;
      }

      if (this.currentBellShedule?.id) body.teachingInfo['schoolBellScheduleId'] = this.currentBellShedule?.id;
      const updateUser = await this.authService.updateUser(this.user.id, body, true);
      if (updateUser) {
        const storageData = await this.storageService.getItem('user');
        this.storageService.removeItem('user');
        storageData.user = updateUser;
        this.storageService.setItem('user', storageData);
        await this.router.navigateByUrl('/test-quizzes');
        if (!('isClassroomsSetup' in (this.user.profileData || {})) || this.user.profileData.isClassroomsSetup) {
          this.openWelcomeModal();
        }
      }
      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      console.log('submit error', error);
    }
  }

  async getLessonPlansPerClassroomsAndUpdateDates(classrooms: Classroom[]) {
    try {
      const ids = classrooms?.map((x) => x.id);

      const lessonPlans = await this.teacherLessonPlanService.getTeacherLessonPlanByClassroomIds({
        classroom_ids: ids,
      });

      if (lessonPlans?.length > 0) {
        lessonPlans.forEach((lessonPlan) => {
          // Extract day name from the start timestamp
          const lessonDay = this.getDayFromTimestamp(lessonPlan.start);

          // Find the matching teacher period
          const matchingPeriod = this.teacherPeriods.find(
            (period) =>
              period.day.toLowerCase() === lessonDay.toLocaleLowerCase() &&
              period.subject_id === lessonPlan.subject_id &&
              period.grades_id === lessonPlan.grades_id,
          );

          // If a matching period is found, update the lesson plan timings
          if (matchingPeriod) {
            lessonPlan.start = new Date(lessonPlan.start).setHours(
              new Date(matchingPeriod.start).getHours(),
              new Date(matchingPeriod.start).getMinutes(),
              new Date(matchingPeriod.start).getSeconds(),
              new Date(matchingPeriod.start).getMilliseconds(),
            );

            lessonPlan.end = new Date(lessonPlan.end).setHours(
              new Date(matchingPeriod.end).getHours(),
              new Date(matchingPeriod.end).getMinutes(),
              new Date(matchingPeriod.end).getSeconds(),
              new Date(matchingPeriod.end).getMilliseconds(),
            );
            lessonPlan.school_id = this.user.school_id;
          }
        });

        const body = {
          teacher_lesson_plan: lessonPlans,
        };
        this.lessonPlanService.updateMultipleLessonPlanEvents(body);
      }
    } catch (error) {
      console.log(error);
    }
  }

  getDayFromTimestamp(timestamp: number): string {
    const date = new Date(timestamp);
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return days[date.getDay()];
  }

  protected filterTeacher() {
    try {
      if (!this.teachers) {
        return;
      }
      let search = this.teacherFilterCtrl.value;
      if (!search) {
        this.filteredTeacher.next(this.teachers.slice());
        return;
      } else {
        search = search.toLowerCase();
      }
      this.filteredTeacher.next(
        this.teachers.filter(
          (teacher) => (teacher.firstName + ' ' + teacher.lastName).toLowerCase().indexOf(search.toLowerCase()) > -1,
        ),
      );
    } catch (error) {
      // console.log(error);
    }
  }
  openWelcomeModal(): void {
    const dialogRef = this.dialog.open(MatDialogComponent, {
      width: '400px',
      data: {
        title: 'Welcome',
        icon: '/assets/images/portal-logo.png',
        accessCodeLabel: `Welcome to your Respond Edu Portal ${this.isMock ? 'Demo' : ''}`,
        confirmationMessage: 'Let’s take a look around to see some of the useful tools and resources at your disposal.',
        cancelButtonText: 'No',
        confirmButtonText: 'Ok',
        cancelTrackEvent: 'Cancel Confirmation',
        confirmTrackEvent: 'Confirmation',
        trackPage: 'Calendar',
      },
    });
    dialogRef.afterClosed().subscribe(async () => {
      this.authService.sendEvent();
    });
  }

  public toggleCheckBox(event: any, selectedPeriod, day): void {
    try {
      const isChecked = event.checked;

      if (isChecked) {
        // Remove any previously selected period for this day, then add the new one
        this.selectedEvents = this.selectedEvents.filter((x) => x.day !== day);

        this.selectedEvents.push({
          day: day,
          period: selectedPeriod?.title,
          start: toUnixTime(selectedPeriod?.start),
          end: toUnixTime(selectedPeriod?.end),
        });
      } else {
        // If unchecked, remove only this specific period from selectedEvents
        this.selectedEvents = this.selectedEvents.filter(
          (x) =>
            !(
              x.day === day &&
              x.period === selectedPeriod?.title &&
              toUnixTime(x.start) === toUnixTime(selectedPeriod?.start) &&
              toUnixTime(x.end) === toUnixTime(selectedPeriod?.end)
            ),
        );
      }

      // Emit the same object structure (unchanged)
      const obj = {
        day: day,
        end: selectedPeriod?.end,
        start: selectedPeriod?.start,
        period: selectedPeriod?.title,
      };
      //send the subject_id with object structure
      if (this.selectedSubjectTab) {
        obj['subject_id'] = this.selectedSubjectTab.id;
      }
      this.saveWeeklyPeriods.emit({
        event,
        obj,
      });
    } catch (error) {
      console.log(error);
    }
  }
  public openConfirmDeleteDialog(): void {
    const dialogRef = this.dialog.open(MatDialogComponent, {
      width: '400px',
      data: {
        title: 'Delete Instructional Period',
        icon: '/assets/icons/featured icon.svg',
        accessCodeLabel: 'Delete Instructional Period ',
        confirmationMessage: 'Are you sure want to delete this instructional period ?',
        cancelButtonText: 'Cancel',
        confirmButtonText: 'Delete',
        cancelTrackEvent: 'Cancel Delete Instructional Period ',
        confirmTrackEvent: 'Instructional Period Document',
        trackPage: 'Delete',
      },
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        this.deleteTeacherPeriod();
      }
    });
  }

  addSchoolCalendar() {
    try {
      if (this.schoolForm.invalid) {
        Object.keys(this.schoolForm.controls).forEach((field) => {
          const control = this.schoolForm.get(field);

          control.markAsTouched({
            onlySelf: true,
          });
        });
      } else {
        this.openConfirmationDialog();
      }
    } catch (error) {
      console.log(error);
    }
  }

  async createNewSchoolForUser() {
    try {
      this.spinner.show();
      const school = await this.schoolService.schoolById(this.user.school_id ? this.user.school_id : 0);
      if (school && school['id']) {
        const body = school;
        body['start_time'] = this.schoolForm.value.startTime;
        body['end_time'] = this.schoolForm.value.endTime;
        body['start_date'] = this.schoolForm.value.startDate;
        body['end_date'] = this.schoolForm.value.endDate;
        const res = await this.schoolService.updateSchool(school['id'], body);
        if (res && res['id']) {
          const userBody = {
            ...this.user,
            isNewUser: false,
            school_id: res['id'],
            profileData: {
              ...this.user?.profileData,
              currentRoute: '/test-quizzes',
            },
            // teachingInfo: {
            //   bellShedule: 'false',
            //   teachingGrades: this.user.teachingInfo.teachingGrades,
            //   teachingSubject: this.user.teachingInfo.teachingSubject,
            // },
          };
          const updateUser = await this.authService.updateUser(this.user?.id, userBody, true);
          const body = {
            school_id: res['id'],
            start: res['start_date'],
            end: res['end_date'],
            holidays: [],
            pupil_free: [],
            acceleration: [],
            unassigned: [],
            bank_days: [],
            instructional_days: 0,
            // Made the isActivate and isFirst true to activate the calendar for teacher only user
            isActivate: true,
            isFirst: true,
          };
          await this.calendarService.addEvent(body);
          if (updateUser) {
            const storageData = await this.storageService.getItem('user');
            this.storageService.removeItem('user');
            storageData.user = updateUser;
            this.storageService.setItem('user', storageData);
            // if (!(await this.checkStripeCustomerIsExist())) {
            //   console.log('Customer does not exist, creating...');
            //   await this.createCustomer();
            // } else {
            //   console.log('Customer already exists, skipping creation.');
            // }
            await this.router.navigateByUrl('/test-quizzes');
          }
        }
      } else {
        const code = this.utilService.randomString(8);
        const getAllSchools = await this.schoolService.getAllSchools();
        if (Array.isArray(getAllSchools)) {
          const isCodeExists = getAllSchools.some((x) => x.code === code);
          if (!isCodeExists) {
            const randomSchoolName = `teachers_only_school_${code}`;
            await this.assignSchoolToUser(randomSchoolName, code);
          }
        }
      }
      // send welcome email commented for portal
      // await this.sendWelcomeEmail(this.user);
      this.spinner.hide();
    } catch (error) {}
  }

  async assignSchoolToUser(schoolName: string, code: string) {
    try {
      const body = {
        name: schoolName,
        state: '',
        country: '',
        code: code,
        phone: 0,
        school_periods: [],
        start_time: this.schoolForm.value.startTime,
        end_time: this.schoolForm.value.endTime,
        start_date: this.schoolForm.value.startDate,
        end_date: this.schoolForm.value.endDate,
        isNew: true,
        limitedUserNumber: {},
        school_logo_id: 0,
        isSchoolOnboarded: false,
        user_limitations: {},
        is_trial_school: false,
        schoolData: {},
      };
      const res = await this.schoolService.addSchool(body);
      if (res && res.id) {
        const userBody = {
          ...this.user,
          school_id: res.id,
          isNewUser: false,
          profileData: {
            ...this.user?.profileData,
            currentRoute: '/test-quizzes',
          },
        };
        const updateUser = await this.authService.updateUser(this.user?.id, userBody, true);
        const body = {
          school_id: res.id,
          start: res.start_date,
          end: res.end_date,
          holidays: [],
          pupil_free: [],
          acceleration: [],
          unassigned: [],
          bank_days: [],
          instructional_days: 0,
          // Made the isActivate and isFirst true to activate the calendar for teacher only user
          isActivate: true,
          isFirst: true,
        };
        await this.calendarService.addEvent(body);
        if (updateUser) {
          const storageData = await this.storageService.getItem('user');
          this.storageService.removeItem('user');
          storageData.user = updateUser;
          this.storageService.setItem('user', storageData);
          // if (!(await this.checkStripeCustomerIsExist())) {
          //   console.log('Customer does not exist, creating...');
          //   await this.createCustomer();
          // } else {
          //   console.log('Customer already exists, skipping creation.');
          // }
          await this.router.navigateByUrl('/test-quizzes');
        }
      }
    } catch (error) {}
  }

  validateSchoolEndTime() {
    this.schoolForm.controls['endTime'].setValidators([
      Validators.required,
      dateTimeValidator(this.schoolForm.controls['startTime'], 'time'),
    ]);

    this.schoolForm.get('startTime')?.valueChanges.subscribe({
      next: () => {
        this.schoolForm.get('endTime')?.updateValueAndValidity();
      },
      error: (err) => {
        // console.error('Error occurred:', err);
      },
      complete: () => {
        // console.log('Value changes subscription completed');
      },
    });
  }

  validateSchoolDate() {
    const startDateControl = this.schoolForm.controls['startDate'];
    const endDateControl = this.schoolForm.controls['endDate'];

    // Set initial validators for endDate
    const updateEndDateValidators = () => {
      endDateControl.setValidators([Validators.required, dateTimeValidator(startDateControl, 'date')]);
      endDateControl.updateValueAndValidity({
        onlySelf: true,
        emitEvent: true,
      });
    };
    const onStartDateChange = () => {
      endDateControl.setValue(null);
      updateEndDateValidators();
    };
    startDateControl.valueChanges.subscribe({
      next: onStartDateChange,
      error: (err) => {
        // console.error('Error occurred while observing startDate changes:', err);
      },
      complete: () => {
        // console.log('Start date value changes subscription completed');
      },
    });
    updateEndDateValidators();
  }
  async checkStripeCustomerIsExist(): Promise<boolean> {
    try {
      const user = await this.storageService.getItem('user');
      const response: any = await this.creditPointService.getSubscriptionByUserId({
        user_id: user.user?.id,
      });
      if (response && response.stripe_customer_id) {
        return !!response;
      }
      return !!response;

      // const stripeCustomerId = user?.user.subscription_details?.stripe_customer_id;
      // console.log('Stripe Customer ID:', stripeCustomerId);
      // return !!stripeCustomerId;
    } catch (error) {
      console.error('Error checking Stripe customer ID:', error);
      return false;
    }
  }

  async createCustomer() {
    const user = await this.storageService.getItem('user');
    const response = await this.paymentService.createCustomer(user);
    if (response && response.xanoData) {
    }
  }
  /**
   * @description We are taking the selected tab as input. For multi-subject classroom we are storing teacher-only data in one variable and filter that data according to tab selection.
   * @param selectedSubjectTab
   */
  updateMultiSubjectEvent(selectedSubjectTab: any) {
    this.teacherOnlyClassroomData = this.teacherOnlyClassroom;

    const allEvents = this.teacherOnlyClassroomData?.extras?.eventDates || [];

    const subjectEvents = allEvents.filter((event: any) => event.subjectId === selectedSubjectTab.id);

    this.teacherOnlyClassroomData = {
      ...this.teacherOnlyClassroomData,
      extras: {
        ...this.teacherOnlyClassroomData?.extras,
        eventDates: subjectEvents,
      },
    };
  }

  /**
   * @description Sending the welcome email for teacher-only user
   */
  async sendWelcomeEmail(user: any) {
    try {
      const emailBody = await this.emailService.getEmailBody(user, EMAIL_TEMPLATE_TYPE.WELCOME);
      await this.authService.sendUserEmail(emailBody);
    } catch (error) {
      console.log('TeacherPeroidsComponent ~ sendWelcomeEmail ~ error:', error);
    }
  }

  // Fetch newly added academic year teaching information
  async getNewlyAddedTeachingInformation() {
    const user = this.storageService.getItem('user');
    const calendar: SchoolCalendar = this.storageService.getItem('selectedSchoolCalendarByAdmin');
    const parmas = {
      user_id: this.isAdminDashboard ? this.currentUser : user?.user?.id,
      school_id: this.isAdminDashboard ? this.user.school_id : user?.user?.school_id,
      school_calendar_id: calendar?.isFirst ? 0 : calendar?.id,
    };
    this.currentTeachingInformation = await this.calendarService.academicInformationByCalendarId(parmas);
    return this.currentTeachingInformation;
  }

  // Update academic information with the new bell schedule
  async getAcademicInformation() {
    try {
      this.currentTeachingInformation = await this.getNewlyAddedTeachingInformation();

      const teachingInfo = this.currentTeachingInformation[0];
      if (this.title === 'teacherNewAcademicYearSetup') {
        teachingInfo['isActive'] = true;
        teachingInfo.teachingInfo.schoolBellScheduleId = this.currentBellShedule?.id;
      }
      await this.calendarService.updateTeacherAcademicInformation(
        this.currentTeachingInformation?.[0]?.id,
        teachingInfo,
      );
    } catch (error) {
      // console.log(error);
    }
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.subscriptionEvents.unsubscribe();
    this.schoolCalendarSubScription?.unsubscribe();
  }
}
